import { inject, Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { I18nService } from '../../core/services/i18n.service';
import { PaymentDataService } from './payment-data.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsProviderService {

  i18n = inject(I18nService);
  paymentDataService = inject(PaymentDataService);

  public currencyList: SelectItem[] = [
    {value: 'EUR', label: 'EUR'},
    {value: 'USD', label: 'USD'},
    {value: 'CHF', label: 'CHF'},
    {value: 'GBP', label: 'GBP'},
    {value: 'CAD', label: 'CAD'},
    {value: 'DKK', label: 'DKK'},
    {value: 'SEK', label: 'SEK'},
    {value: 'NOK', label: 'NOK'},
    {value: 'JPY', label: 'JPY'}
  ];

  paymentPageLanguages(): SelectItem[] {
    switch (this.i18n.activeLanguageKey()) {
      case 'de':
        return [
          {value: 'de', label: 'Deutsch'},
          {value: 'en', label: 'Englisch'}
        ];
      case 'en':
        return [
          {value: 'en', label: 'English'},
          {value: 'de', label: 'German'}
        ];
    }
  }

  public customerType: SelectItem[] = [
    {value: 'SPARKASSE', label: this.i18n.i18nLng()['SAVINGBANK']},
    {value: 'RECHENZENTRUM', label: this.i18n.i18nLng()['DATACENTER']},
    {value: 'KOMMUNE', label: this.i18n.i18nLng()['MUNICIPALITY']},
    {value: 'INTERN', label: this.i18n.i18nLng()['INTERNAL']},
  ];

  public customerGroup: SelectItem[] = [
    {value: 'DIRECT', label: this.i18n.i18nLng()['CUSTOMER_GROUP_DIRECT']},
    {value: 'SID', label: this.i18n.i18nLng()['CUSTOMER_GROUP_SID']},
    {value: 'UNINRW', label: this.i18n.i18nLng()['CUSTOMER_GROUP_UNINRW']},
  ];

  public organizationType: SelectItem[] = [
    {value: 'BUND', label: 'Bund'},
    {value: 'LAND', label: 'Bundesland'},
    {value: 'GEMEINDE', label: 'Gemeinde(verband) / Stadt'},
    {value: 'KREISSTADT', label: 'Große Kreisstadt'},
    {value: 'KREISFREI', label: 'Kreisfreie Stadt / Stadtkreis'},
    {value: 'RECHENZENTRUM', label: 'Kommunale Rechenzentren / IT-Dienstleister'},
    {value: 'UNTERNEHMEN_OEFFENTLICH', label: 'Öffentliches Unternehmen / kommunaler Eigenbetrieb'},
    {value: 'VEREIN', label: 'Verein'},
    {value: 'LANDESBANK', label: 'Landesbank'},
    {value: 'SPARKASSE', label: 'Sparkasse'},
    {value: 'VERBUND', label: 'Sparkassenverbund-Unternehmen'},
    {value: 'UNTERNEHMEN_PRIVAT', label: 'Unternehmen (privatwirtschaftlich)'}
  ];

  public shopType: SelectItem[] = [
    {value: 'RETAIL', label: this.i18n.i18nLng()['RETAIL']},
    {value: 'GAMBLING', label: this.i18n.i18nLng()['GAMBLING']},
    {value: 'HEALTHCARE', label: this.i18n.i18nLng()['HEALTHCARE']},
    {value: 'TELCO', label: this.i18n.i18nLng()['TELCO']},
    {value: 'TRAVEL', label: this.i18n.i18nLng()['TRAVEL']},
    {value: 'OTHER', label: this.i18n.i18nLng()['OTHER']},
  ];

  public cardType: SelectItem[] = [
    {value: 'MASTERCARD', label: 'Mastercard'},
    {value: 'VISA', label: 'Visa'},
    {value: 'AMEX', label: 'American Express'},
    {value: 'DINERS', label: 'Diners Club'},
    {value: 'JCB', label: 'JCB'},
  ];

  public cardAcceptancePoint: SelectItem[] = [
    {value: 'PAYONE', label: 'Payone'},
    {value: 'AMEX', label: 'Amex'},
    {value: 'SIMULATION', label: 'Simulation'},
  ];

  public contractOptions: SelectItem[] = [
    {value: 'ECOM_3DS', label: 'ECOM_3DS'},
    {value: 'ECOM_MOTO_3DS', label: 'ECOM_MOTO_3DS'},
    {value: 'ECOM_MOTO', label: 'ECOM_MOTO'},
    {value: 'ECOM', label: 'ECOM'},
    {value: 'MOTO', label: 'MOTO'},
  ];

  public billingType: SelectItem[] = [
    {value: 'BATCH', label: this.i18n.i18nLng()['BT_BATCH']},
    {value: 'INDIVIDUAL', label: this.i18n.i18nLng()['BT_INDIVIDUAL']},
  ];

  public customerPaymentMethod: SelectItem[] = [
    {value: 'CUSTOMERPAYMENTDIRECTDEBIT', label: this.i18n.i18nLng()['CUSTOMERPAYMENTDIRECTDEBIT']},
    {value: 'CUSTOMERPAYMENTBANKTRANSFER', label: this.i18n.i18nLng()['CUSTOMERPAYMENTBANKTRANSFER']},
  ];

  /*
  public ePayBL: SelectItem[] = [
    { value: 'EPAYBL_SACHSEN', label: 'Sachsen' },
    { value: 'EPAYBL_KOMMONE', label: 'Komm.ONE' },
    { value: 'EPAYBL_KDN_KOELN', label: 'KDN Köln' },
    { value: 'EPAYBL_KDN_KRZ_LEMGO', label: 'KDN KRZ Lemgo' },
    { value: 'EPAYBL_DATAPORT', label: 'Dataport' },
    { value: 'EPAYBL_DATAPORT_SH', label: 'Dataport Schleswig-Holstein' },
    { value: 'EPAYBL_DATAPORT_HH', label: 'Dataport Freie Hansestadt Hamburg' },
    { value: 'EPAYBL_TLRZ_TH', label: 'TLRZ Thüringen' },
    { value: 'EPAYBL_BREMEN_FINANZEN', label: 'Der Senator für Finanzen Bremen' },
    { value: 'EPAYBL_ZFB_BUND', label: 'ZFB – Zentrales Finanzministerium des Bundes' },
    { value: 'EPAYBL_AKDB', label: 'AKDB' },
    { value: 'EPAYBL_SACHSEN_ANHALT', label: 'Ministerium für Finanzen Sachsen-Anhalt' },
    { value: 'EPAYBL_SONSTIGE', label: 'Sonstige Abrufberechtigte' }
  ]
   */

  public ePayBL: SelectItem[] = [
    { value: 'EPAYBL_AKDB', label: 'AKDB' },
    { value: 'EPAYBL_DATAPORT', label: 'Dataport' },
    { value: 'EPAYBL_DIKOMM', label: 'Dikomm' },
    { value: 'EPAYBL_EGO-MV', label: 'eGo-MV' },
    { value: 'EPAYBL_EGO-SAAR', label: 'eGo-Saar' },
    { value: 'EPAYBL_EKOM21', label: 'ekom21' },
    { value: 'EPAYBL_GKD_RECKLINGHAUSEN', label: 'GKD Recklinghausen' },
    { value: 'EPAYBL_GOVCONNECT', label: 'GovConnect' },
    { value: 'EPAYBL_ITK_RHEINLAND', label: 'ITK Rheinland' },
    { value: 'EPAYBL_KDN_STADT_KOELN', label: 'KDN - Stadt Köln' },
    { value: 'EPAYBL_KDVZ_FRECHEN', label: 'KDVZ Frechen' },
    { value: 'EPAYBL_KID_MAGDEBURG', label: 'KID Magdeburg' },
    { value: 'EPAYBL_KIV_THUERINGEN', label: 'KIV Thüringen' },
    { value: 'EPAYBL_KOMM_ONE', label: 'Komm.ONE' },
    { value: 'EPAYBL_KOMMWIS', label: 'KommWis' },
    { value: 'EPAYBL_KOMUNA', label: 'Komuna' },
    { value: 'EPAYBL_KRZN', label: 'KRZN' },
    { value: 'EPAYBL_NEXTGOV_IT', label: 'nextGov IT' },
    { value: 'EPAYBL_OWL_IT', label: 'OWL IT' },
    { value: 'EPAYBL_SIT_NRW', label: 'SIT NRW' },
    { value: 'EPAYBL_TLRZ', label: 'TLRZ' },
    { value: 'EPAYBL_DATAPORT_HH', label: 'Dataport - Freie und Hansestadt Hamburg' },
    { value: 'EPAYBL_DATAPORT_SACHSEN-ANHALT', label: 'Dataport - Sachsen-Anhalt' },
    { value: 'EPAYBL_DATAPORT_SH', label: 'Dataport - Schleswig-Holstein' },
    { value: 'EPAYBL_KOPFSTELLE_BREMEN', label: 'ePayBL Kopfstelle Freie Hansestadt Bremen' },
    { value: 'EPAYBL_IT_NRW', label: 'IT.NRW' },
    { value: 'EPAYBL_KOPFSTELLE_RHEINLAND-PFALZ', label: 'Kopfstelle ePayment Rheinland-Pfalz' },
    { value: 'EPAYBL_LANDESAMT_FUER_FINANZEN_MECKLENBURG-VORPOMMERN', label: 'Landesamt für Finanzen Mecklenburg-Vorpommern' },
    { value: 'EPAYBL_MINISTERIUM_DES_INNERN_UND_FUER_KOMMUNALES_BRANDENBURG', label: 'Ministerium des Innern und für Kommunales Brandenburg' },
    { value: 'EPAYBL_SACHSEN', label: 'Sachsen' },
    { value: 'EPAYBL_SONSTIGE', label: 'Sonstige' },
    { value: 'EPAYBL_TLRZ_THUERINGEN', label: 'TLRZ Thüringen' },
    { value: 'EPAYBL_ZENTRALES_FINANZWESEN_DES_BUNDES', label: 'Zentrales Finanzwesen des Bundes' },
    { value: 'EPAYBL_STADT_MUENSTER_RECHENZENTRUM', label: 'Stadt Münster Rechenzentrum' }
  ]


  public legalForm: SelectItem[] = [
    {value: '1', label: 'AG'},
    {value: '35', label: 'AG & Co. KG'},
    {value: '3', label: 'e.G.'},
    {value: '2', label: 'e.K.'},
    {value: '4', label: 'e.V.'},
    {value: '5', label: 'Einzelunternehmen'},
    {value: '36', label: 'EWIV'},
    {value: '6', label: 'GbR'},
    {value: '27', label: 'gGmbH'},
    {value: '7', label: 'GmbH'},
    {value: '8', label: 'GmbH & Co. KG'},
    {value: '37', label: 'gUG'},
    {value: '9', label: 'KG'},
    {value: '38', label: 'KG aA'},
    {value: '10', label: 'OHG'},
    {value: '39', label: 'PArtG'},
    {value: '40', label: 'PartG mbB'},
    {value: '13', label: 'AöR'},
    {value: '25', label: 'KdöR'},
    {value: '41', label: 'SCE'},
    {value: '14', label: 'SE'},
    {value: '15', label: 'SE & Co. KG'},
    {value: '42', label: 'SE & Co. KGaA'},
    {value: '43', label: 'SPE'},
    {value: '26', label: 'Stiftung'},
    {value: '44', label: 'SUP'},
    {value: '45', label: 'SUP & Co. KG'},
    {value: '11', label: 'UG'},
    {value: '12', label: 'Sonstige'}
  ];

  public personTitle: SelectItem[] = [
    {value: 'MR', label: this.i18n.i18nLng()['MR']},
    {value: 'MS', label: this.i18n.i18nLng()['MS']},
    {value: 'MX', label: this.i18n.i18nLng()['MX']}
  ];

  public contactPreference: SelectItem[] = [
    {value: 'EMAIL', label: this.i18n.i18nLng()['EMAIL']},
    {value: 'PHONE', label: this.i18n.i18nLng()['PHONE']}
  ];

  public globalActivePaymentMethods(): SelectItem[] {
    let pmList: SelectItem[] = [];
    this.paymentDataService.paymentMethodConfig.map(pm => {
      if (pm.enabled) {
        pmList.push(
          {
            value: pm.name,
            label: this.i18n.i18nLng()[pm.name]
          }
        )
      }
    });
    return pmList;
  }

}
